// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__phlTH","title":"styles_title__5FnPb"};